'use client';

import type { ClassValue } from 'clsx';

import { clsxm } from '@vs-shop/utils';

import type { HomepageTaxon } from '../../../../effect/schema/openapi/backend';

type Props = {
  taxon: HomepageTaxon;
  isCurrent: boolean;
  onSelect: (taxon: HomepageTaxon) => void;
  className?: ClassValue;
};

export default function HomepageTaxonNavigationItem({
  taxon,
  isCurrent,
  onSelect,
  className,
}: Props) {
  const handleClick = () => {
    onSelect(taxon);
  };

  return (
    <button
      type="button"
      title={taxon.name ?? undefined}
      onClick={handleClick}
      aria-pressed={isCurrent}
      data-slot="homepage-taxon-tab"
      className={clsxm(
        'font-heading',
        'group flex h-10 cursor-pointer flex-col justify-between text-xs/[18px] tracking-wider whitespace-nowrap uppercase lap:text-sm/5',
        isCurrent ? 'text-foreground' : 'text-foreground-muted',
        className
      )}
    >
      <span>{taxon.name}</span>
      {isCurrent ? (
        <span className="h-1 w-full rounded-t-full bg-primary lap:rounded-t-none"></span>
      ) : null}
    </button>
  );
}
